import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Retrofitting the Future',
  date: new Date(2023, 6, 30),
  img: '/img/chick.jpeg',
  tracks: [
    {
      title: 'Shells Cracking',
      src: '/songs/2023-07-30/shells_cracking.mp3',
    },
    {
      title: 'Wings Growing',
      src: '/songs/2023-07-30/wings_growing.mp3',
    },
    {
      title: 'Nest Jumping',
      src: '/songs/2023-07-30/nest_jumping.mp3',
    },
    {
      title: 'Flight Taking',
      src: '/songs/2023-07-30/flight_taking.mp3',
    },
    {
      title: 'Wild Oats Sewing',
      src: '/songs/2023-07-30/wild_oats_sewing.mp3',
    },
    {
      title: 'Authority Dodging',
      src: '/songs/2023-07-30/authority_dodging.mp3',
    },
    {
      title: 'Denial Having',
      src: '/songs/2023-07-30/denial_having.mp3',
    },
    {
      title: 'Down Settling',
      src: '/songs/2023-07-30/down_settling.mp3',
    },
    {
      title: 'Serious Getting',
      src: '/songs/2023-07-30/serious_getting.mp3',
    },
  ]
}
export default album;